import { combineReducers } from 'redux'
import * as types from '../../utils/actionTypes'
import { createReducer } from '../../utils/helpers'

const initialState = {
  config: {
    title: 'Konfiguration',
    path: 'konfiguration',
    selectionKey: 'nodes',
    component: 'Configuration',
    minSelect: 1,
    maxSelect: 1,
  },
  rootNode: {},
}

export const config = createReducer(initialState.config, {})


const setConfiguration = (state, payload) => ({
  ...state,
  ...payload,
})

export const rootNode = createReducer(initialState.rootNode, {
  [types.SET_CONFIGURATION]: setConfiguration,
})

// Default Export
export default combineReducers({
  config,
  rootNode,
})



// WEBPACK FOOTER //
// ./src/modules/configuration/reducers.js